import { TrashBaseIcon } from '@tableau/icons/TrashBaseIcon';
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

export type DeleteDomainButtonProps = Readonly<{
    onClick: () => void;
}>;

export function DeleteDomainButton(props: DeleteDomainButtonProps) {
    return (
        <ButtonWidget
            testId="delete-domain-button"
            buttonType={ButtonType.Icon}
            onClick={props.onClick}
            title={Messages.bridgeSiteSettingsDeleteDomain()}
            aria-label={Messages.bridgeSiteSettingsDeleteDomain()}
        >
            <TrashBaseIcon size={14} alt={''} aria-hidden={true} />
        </ButtonWidget>
    );
}
